export const mergePriceBreaks = ({
  basePriceQuantities,
  printRunQuantities
}) => {
  const uniquePriceBreaks = new Set([...(basePriceQuantities || []), ...(printRunQuantities || [])]);
  return Array.from(uniquePriceBreaks).sort((a, b) => a - b);
};